import React, { FC, useMemo } from 'react';
import findIndex from 'lodash/findIndex';

import { Nullable } from 'src/types/nullable.type';
import { Node } from 'src/common/interfaces/node.interface';
import { Journey } from 'src/common/interfaces/journey.interface';
import { getAllNodes } from 'src/utils/journey';
import { useEditorContext } from 'src/store/editor';

interface PlayerProgressBarInterfaceProps {
  journey: Journey;
  currentNode: Nullable<Node>;
}

export const PlayerProgressBar: FC<PlayerProgressBarInterfaceProps> = ({ journey, currentNode }) => {
  const { currentActiveNodeId } = useEditorContext();
  const allNodes = useMemo(() => {
    return getAllNodes(journey);
  }, [journey]);

  const length = useMemo(() => {
    return allNodes.length;
  }, [allNodes]);

  // activeIndex starts from 0 and goes till N - 1 (N is number of nodes)
  const activeIndex = findIndex(allNodes, (n: Node) => n.id === currentActiveNodeId || n.id === currentNode?.id);
  const baseProgress = ((activeIndex + 1) / length) * 100;

  return (
    <div className='hidden md:flex space-x-md items-center'>
      <div className='flex justify-center relative w-[304px] rounded-100'>
        <div className='relative flex flex-1 h-1 bg-bedrock-light-gray rounded-100'>
          <div
            className='absolute left-0 flex h-full z-10 bg-bedrock-brand-primary rounded-100'
            style={{
              width: `${baseProgress}%`,
              transition: 'width 500ms',
            }}
          />
        </div>
      </div>
      <div className='text-bedrock-p-small text-bedrock-black'>
        {activeIndex + 1} / {length}
      </div>
    </div>
  );
};
